var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-5 min-vh-100 d-flex align-items-center justify-content-center flex-column"},[_c('p',{staticClass:"text-success font-weight-bold mt-3 mb-5"},[_vm._v("Redirecting....")]),_vm._v(" "),_c('router-link',{staticClass:"btn-save text-white",attrs:{"to":"/"}},[_vm._v("HOME")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05c62b41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/letsMovie.vue
// module id = 1134
// module chunks = 173